(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Ordine', Ordine);

    Ordine.$inject = ['$resource', 'DateUtils'];

    function Ordine ($resource, DateUtils) {
        var resourceUrl =  'api/ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataProtocolloOrdine = DateUtils.convertLocalDateFromServer(data.dataProtocolloOrdine);
                        data.dataOfferta = DateUtils.convertLocalDateFromServer(data.dataOfferta);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataProtocolloOrdine = DateUtils.convertLocalDateToServer(copy.dataProtocolloOrdine);
                    copy.dataOfferta = DateUtils.convertLocalDateToServer(copy.dataOfferta);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataProtocolloOrdine = DateUtils.convertLocalDateToServer(copy.dataProtocolloOrdine);
                    copy.dataOfferta = DateUtils.convertLocalDateToServer(copy.dataOfferta);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
